module.exports = __webpack_public_path__ + "r-v3/img/download_gray.c3f90a45.svg";